export { default as dispatch } from "./dispatch.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/src/index.js
// module id = 509
// module chunks = 0